import { combineReducers } from 'redux';

// import reducers
import { userReducer } from './userReducer';

export default combineReducers({
    user: userReducer
});
